import { useSwitchr } from '@/lib/switchr/switchr/client';

// https://console.statsig.com/2d7YKn3svx51kl9ppvADhm/gates/fae-675-e2e-gate-test
export const GATE_ID = 'fae-675-e2e-gate-test';

// Shouldn't run in production, used to verify default behavior of experiments
export const GateTestFAE675 = () => {
  const { checkGate } = useSwitchr();

  const gateVal = checkGate(GATE_ID);

  return <span data-automation={`${GATE_ID}-${gateVal}`} aria-hidden="true" />;
};
